declare namespace $ {

	export class $mol_icon_face_agent extends $mol_icon {
		path( ): string
	}
	
}

//# sourceMappingURL=agent.view.tree.d.ts.map